import { WebStorageStateStore, UserManager, Log } from 'oidc-client';
angular.module('Identity', [])
.factory('IdentityFactory', function($http, $location, $rootScope, $q, IDS_URL){

  var activeUser;
  var logoutRedirect;

  var prodDomains = [
    'smartx.managedaccounts.io',
    'smartx.smartxadvisory.com',
    'live-hedgecovest.pantheonsite.io',
    'portal.managedaccounts.io',
    'test-hedgecovest.pantheonsite.io',
    'advisoryplatform.americanportfolios.com',
    'beta.smartxadvisory.com'
  ];
  var isProd = prodDomains.indexOf(window.location.host) > -1;

  var isCognitoSession = localStorage.getItem('smx.auth.issuer') === 'cognito';

  // Seed SmartX.Router synchronously at factory init so that any controller that
  // calls SmartX.Router.getToken() during its own init (e.g. AllocationHoldingsCtrl,
  // main.js) receives the Cognito ID token rather than null.
  // This mirrors the IS path where oidc-client.UserLoaded calls setToken on every load.
  if (isCognitoSession) {
    var _initToken = localStorage.getItem('smx.auth.cognito.id_token');
    if (_initToken) SmartX.Router.setToken(_initToken);
  }

  var config = {
    // authority: 'http://localhost:5000/',
    // authority: /* window.location.host.indexOf('localhost') > -1 ? "http://localhost:5000" : */ "https://identity-uat.smartxadvisory.com/", // to access the locally running .NET application
    // authority: "http://192.168.3.131:5000",
    authority: IDS_URL, // isProd ? 'https://identity.smartxadvisory.com/' : 'https://ids.svc.qa.smartx.us/',
    client_id: "smartx-clientapi-webclient",
    redirect_uri: window.location.origin + "/identity/callback.html",
    response_type: "id_token token",
    scope: "offline_access openid email profile smartx_profile roles",
    post_logout_redirect_uri : window.location.origin + "/login",
    revokeAccessTokenOnSignout: true,

    automaticSilentRenew: !isCognitoSession,
    silent_redirect_uri: window.location.origin + "/identity/silent-renew.html",

    accessTokenExpiringNotificationTime: 60,
    silentRequestTimeout: 10000,

    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: !isCognitoSession,
    checkSessionInterval: 2000,
    
    userStore: new WebStorageStateStore({ store: window.localStorage })
  };

  console.log("Oidc config: ", config);

  var idClient = new UserManager(config);

  console.log(idClient);

  // enable logging from oidc-client
  Log.logger = console;

  idClient.events.addAccessTokenExpiring(function(){
    console.log("token expiring...");
  });

  // token needs to be reset when silent renew completes
  idClient.events.addUserLoaded(function(user){
    console.log("User session was updated...");
    SmartX.Router.setToken(user.access_token);

    // listen for this event in a controller as a way to access the updated token
    // useful for keeping the token fresh inside of custom elements that need to make API calls (token can be passed in as a prop)
    // $applyAsync ensures Angular's digest runs after this oidc-client callback (which fires outside Angular's zone)
    // so that {{ smartx_token }} bindings — and therefore auth-token props on CDN web components — update immediately.
    $rootScope.$applyAsync(function() {
      $rootScope.$broadcast('smx-token-updated', user.access_token);
    });

    // alternative that could be used directly by custom elements if we don't want to depend on an angular controller
    // can be listened to with the vanillaJS addEventListener
    // var event = new CustomEvent("smx-token-updated", { bubbles: true, detail: vm.token + Math.random() });
    // document.dispatchEvent(event);
  });
  
  function getUser () {
    // For Cognito sessions, resolve immediately from localStorage.
    // IS sessions continue to use oidc-client as before.
    var issuer = localStorage.getItem(COGNITO_KEYS.issuer);
    if (issuer === 'cognito') {
      // Use the ID token for API Gateway calls — the API Gateway authorizer validates
      // Cognito ID tokens. The access token is Cognito-internal and causes 403s.
      var token = localStorage.getItem(COGNITO_KEYS.idToken) || '';
      // TODO: populate profile from jwt_decode(id_token) so callers of
      // getUser().profile get the same fields as IS callers (given_name, email, etc.).
      // Currently MenuCtrl.js decodes the ID token itself as a workaround.
      // Track as follow-up — safe for V1 since no other caller reads .profile.
      return $q.resolve(token ? { access_token: token, profile: {} } : null);
    }
    return idClient.getUser();
  }

  function getIssuer () {
    return localStorage.getItem(COGNITO_KEYS.issuer);
  }

  // Clears the oidc-client IS session from localStorage and stops silent renew/session
  // monitoring. Called when a Cognito login completes so the IS session doesn't linger.
  function clearIsSession () {
    idClient.removeUser();
  }

  function getActiveUser () {
    return activeUser;
  }

  function getAuthority () {
    return config.authority;
  }

  function getPasswordLink () {
    // Password management lives on the IS identity server — not available for Cognito users.
    var issuer = localStorage.getItem(COGNITO_KEYS.issuer);
    if (issuer === 'cognito') return null;
    return config.authority + 'Manage/ChangePassword';
  }

  function getProfileLink () {
    // Profile management lives on the IS identity server — not available for Cognito users.
    var issuer = localStorage.getItem(COGNITO_KEYS.issuer);
    if (issuer === 'cognito') return null;
    return config.authority + 'Manage';
  }

  function setActiveUser (user) {
    console.log("Setting authenticated user", user);
    activeUser = user;
  }

  function getProfile () {
    return $http.get(config.authority + 'connect/userinfo', {
      headers: {
        Authorization: 'Bearer ' + SmartX.Router.getToken()
      }
    });
  }

  function updateProfile (profile) {

  }

  function login (params) {
    idClient.signinRedirect(params);
  }

  function logout (params) {
    var issuer = localStorage.getItem(COGNITO_KEYS.issuer);

    // ------------------------------------------------------------------
    // Cognito signout — SmartX-level only, no SAML SLO to WF's IdP (V1)
    // ------------------------------------------------------------------
    if (issuer === 'cognito') {
      var cfg          = getCognitoConfig();
      var refreshToken = localStorage.getItem(COGNITO_KEYS.refreshToken);

      // 1. Revoke the refresh token (best-effort, fire-and-forget)
      if (cfg.domain && cfg.clientId && refreshToken) {
        var revokeBody = new URLSearchParams({
          token:     refreshToken,
          client_id: cfg.clientId
        });
        fetch(cfg.domain + '/oauth2/revoke', {
          method:    'POST',
          headers:   { 'Content-Type': 'application/x-www-form-urlencoded' },
          body:      revokeBody.toString(),
          keepalive: true
        }).catch(function (e) {
          console.warn('[Identity] Cognito token revocation failed:', e.message);
        });
      }

      // 2. Clear the local Cognito session from localStorage.
      // The issuer key is intentionally preserved — it is not a security token.
      // It acts as a routing hint so that users who navigate directly to
      // /v3/dashboard after logout (or whose session expires) are redirected
      // back to the Cognito login page instead of the Identity Server.
      Object.keys(COGNITO_KEYS).forEach(function (k) {
        if (k !== 'issuer') localStorage.removeItem(COGNITO_KEYS[k]);
      });

      // 3. Redirect to Cognito /logout, landing on the post-logout page
      var postLogoutUri = (window.Drupal && Drupal.settings && Drupal.settings.cognito_post_logout_url)
                          ? Drupal.settings.cognito_post_logout_url
                          : window.location.origin + '/login?provider=cognito';

      if (cfg.domain && cfg.clientId) {
        window.location.replace(
          cfg.domain + '/logout' +
          '?client_id=' + encodeURIComponent(cfg.clientId) +
          '&logout_uri=' + encodeURIComponent(postLogoutUri)
        );
      } else {
        window.location.replace(postLogoutUri);
      }

      return;
    }

    // ------------------------------------------------------------------
    // Identity Server signout — existing behaviour, unchanged
    // ------------------------------------------------------------------
    if (logoutRedirect) {
      var logout = { post_logout_redirect_uri: logoutRedirect.trim() };
      params = params ? _.extend(params, logout) : logout;
    }

    var urlParams = $location.search();
    var jumpto = urlParams.jumpto;
    var extraQuery;

    if (jumpto === 'account'){
      var jumptoAccount;
      if (urlParams.accountId) {
        jumptoAccount = urlParams.accountId;
        window.localStorage.setItem('smxJumptoAccountId', jumptoAccount);
      } else if (urlParams.accountNumber) {
        jumptoAccount = urlParams.accountNumber;
        window.localStorage.setItem('smxJumptoAccountNumber', jumptoAccount);

      }

      extraQuery = 'jumpto=account';
    }

    if (extraQuery){

      // figure out if we need the jumpto params to be prefixed with a ? or &
      // if the logout url already has some params, use &jumpto
      // if it doesn't use ?jumpto
      if (logoutRedirect) {
        var hasQuery = params.post_logout_redirect_uri.indexOf('?') > -1;
        if (hasQuery) {
          params.post_logout_redirect_uri += ('&' + extraQuery);
        } else {
          params.post_logout_redirect_uri += ('?' + extraQuery);
        }
      } else {
        params = {
          post_logout_redirect_uri:  config.post_logout_redirect_uri += ('?' + extraQuery)
        };
      }
    }

    idClient.signoutRedirect(params);
  }

  function setLogoutRedirect (url) {
    logoutRedirect = url;
  }

  // ---------------------------------------------------------------------------
  // Cognito refresh — only active when issuer === 'cognito'.
  // IS sessions continue to use oidc-client's automaticSilentRenew unchanged.
  // ---------------------------------------------------------------------------
  var COGNITO_KEYS = {
    issuer:       'smx.auth.issuer',
    accessToken:  'smx.auth.cognito.access_token',
    idToken:      'smx.auth.cognito.id_token',
    refreshToken: 'smx.auth.cognito.refresh_token',
    expiresAt:    'smx.auth.cognito.expires_at'
  };

  // Seconds before expiry at which a proactive refresh is triggered.
  // Mirrors accessTokenExpiringNotificationTime used for IS.
  var COGNITO_EXPIRY_BUFFER = 60;

  function getCognitoConfig () {
    var d = (window.Drupal && Drupal.settings) ? Drupal.settings : {};
    return {
      domain:   d.cognito_domain   || null,
      clientId: d.cognito_client_id || null
    };
  }

  function refreshCognitoToken () {
    var cfg          = getCognitoConfig();
    var refreshToken = localStorage.getItem(COGNITO_KEYS.refreshToken);

    if (!cfg.domain || !cfg.clientId || !refreshToken) {
      console.warn('[Identity] Cognito refresh skipped — missing domain, client_id, or refresh token');
      return;
    }

    var body = new URLSearchParams({
      grant_type:    'refresh_token',
      client_id:     cfg.clientId,
      refresh_token: refreshToken
    });

    fetch(cfg.domain + '/oauth2/token', {
      method:  'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body:    body.toString()
    })
    .then(function (res) {
      if (!res.ok) {
        return res.json().then(function (err) {
          throw new Error(err.error_description || err.error || 'Cognito refresh failed (' + res.status + ')');
        });
      }
      return res.json();
    })
    .then(function (tokens) {
      localStorage.setItem(COGNITO_KEYS.accessToken, tokens.access_token);
      if (tokens.id_token)      localStorage.setItem(COGNITO_KEYS.idToken,      tokens.id_token);
      if (tokens.refresh_token) localStorage.setItem(COGNITO_KEYS.refreshToken, tokens.refresh_token);
      localStorage.setItem(COGNITO_KEYS.expiresAt, String(Math.floor(Date.now() / 1000) + (tokens.expires_in || 3600)));

      // Keep SmartX SDK and Angular in sync — use ID token (not access token) so that
      // API Gateway authorizer calls continue to succeed after a refresh.
      var activeToken = tokens.id_token || localStorage.getItem(COGNITO_KEYS.idToken);
      SmartX.Router.setToken(activeToken);
      // $applyAsync schedules a digest after this native fetch() .then() callback so
      // {{ smartx_token }} bindings on CDN web components pick up the refreshed token immediately.
      $rootScope.$applyAsync(function() {
        $rootScope.$broadcast('smx-token-updated', activeToken);
      });

      console.log('[Identity] Cognito token refreshed successfully');
    })
    .catch(function (e) {
      console.error('[Identity] Cognito token refresh error:', e.message);

      // If the refresh token is expired or revoked, Cognito returns invalid_grant.
      // There is no recovery from this — force a clean logout so the user is
      // redirected to the Cognito login page rather than silently going stale.
      if (e.message && e.message.indexOf('invalid_grant') > -1) {
        console.warn('[Identity] Refresh token expired or revoked — forcing Cognito logout');
        logout();
      }
    });
  }

  // Poll every 30 s. No-ops for IS sessions (issuer !== 'cognito').
  // Fires refreshCognitoToken when the stored access token is within
  // COGNITO_EXPIRY_BUFFER seconds of expiry.
  setInterval(function () {
    if (localStorage.getItem(COGNITO_KEYS.issuer) !== 'cognito') return;

    var expiresAt  = parseInt(localStorage.getItem(COGNITO_KEYS.expiresAt) || '0', 10);
    var nowSeconds = Math.floor(Date.now() / 1000);

    if (expiresAt && (expiresAt - nowSeconds) <= COGNITO_EXPIRY_BUFFER) {
      console.log('[Identity] Cognito token expiring soon, refreshing...');
      refreshCognitoToken();
    }
  }, 30000);

	return {
    getUser: getUser,
    getIssuer: getIssuer,
    clearIsSession: clearIsSession,
    getProfileLink: getProfileLink,
    setActiveUser: setActiveUser,
    getActiveUser: getActiveUser,
    getProfile: getProfile,
    updateProfile: updateProfile,
    login: login,
    logout: logout,
    setLogoutRedirect: setLogoutRedirect,
    getPasswordLink: getPasswordLink,
    getAuthority: getAuthority,
    refreshCognitoToken: refreshCognitoToken
	};
});